import api from "../utils/API";

const getAllCompetencesMetiersForSelect = () => {
  return api.get(`/gestion/competencemetierforselect/list`);
};
const getCompetencesMetiersDetails = (uuid) => {
  return api.get(`/gestion/competencemetier/${uuid}/details`);
};
export {getAllCompetencesMetiersForSelect, getCompetencesMetiersDetails};
